function PathNotFound() {
    return <main>
        <h2>Page not found</h2>
    </main>
}

export default PathNotFound;